"use client"

import { useState } from "react";
import Image from "next/image";
import PressLightbox from "./PressLightbox";

interface PressCoverProps {
  src: string;
  alt: string;
  aspectRatio?: number;
  className?: string;
  priority?: boolean;
}

/**
 * Dedicated component for Digital Edition cover art.
 * Optimized for high-fidelity edge-to-edge coverage and portal-based viewing.
 */
export default function PressCover({
  src,
  alt,
  aspectRatio,
  className = "",
  priority = false
}: PressCoverProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div
        className={`group cursor-zoom-in relative overflow-hidden w-full h-full bg-muted/30 transition-shadow hover:shadow-2xl ${className}`}
        onClick={() => setIsOpen(true)}
      >
        <Image
          src={src}
          alt={alt}
          fill
          className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110 grayscale group-hover:grayscale-0"
          priority={priority}
          sizes="(max-width: 768px) 100vw, 50vw"
        />

        {/* Intelligence Overlay */}
        <div className="absolute inset-0 bg-brand/10 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
          <div className="bg-background/95 px-5 py-2 text-[10px] font-black uppercase tracking-[0.3em] text-foreground shadow-2xl border border-border">
            Focus Visual
          </div>
        </div>
      </div>

      <PressLightbox
        src={src}
        alt={alt}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
}
